/** Status tag with a pulsing ring. Amber/blue for roadmap stages, green
 *  for shipped ("Live") features. */
export default function WipTag({
  label,
  variant = "amber",
}: {
  label: string;
  variant?: "amber" | "blue" | "green";
}) {
  const tone =
    variant === "blue"
      ? "text-data-blue bg-data-blue/[0.09] border-data-blue/30"
      : variant === "green"
        ? "text-data-green bg-data-green/[0.09] border-data-green/30"
        : "text-data-amber bg-data-amber/10 border-data-amber/30";
  const dot =
    variant === "blue" ? "bg-data-blue" : variant === "green" ? "bg-data-green" : "bg-data-amber";

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border py-[5px] pl-[9px] pr-[11px] text-xs font-semibold tracking-[0.02em] ${tone}`}
    >
      <span className={`relative h-[7px] w-[7px] rounded-full ${dot}`}>
        <span className="absolute -inset-[3px] animate-wip-pulse rounded-full border-[1.5px] border-current opacity-50" />
      </span>
      {label}
    </span>
  );
}
